<template>
  <SectionTemplate
    class="interact-section"
    title="从创作到互动，有言一站式PPT智能升级工具"
    :desc="sectionDesc"
  >
    <div class="interact-section__card-list">
      <EditCard :data="item" v-for="item in cardList" :key="item.title">
        <template #btn>
          <div class="interact-section__card-btns">
            <ArrowBtn
              class="interact-section__card-btn"
              text="免费试用"
              variant="purple-common"
              @click="handleTrial(item.freeLink)"
            />
            <Button
              class="interact-section__card-btn"
              variant="border-white-middle"
              @click="handleViewDetail(item.name)"
              >查看详情</Button
            >
          </div>
        </template>
      </EditCard>
    </div>
  </SectionTemplate>
</template>

<script setup lang="ts">
import { PageKey } from '@/constants/page';
import ArrowBtn from '@/design/components/buttons/arrow-btn.vue';
import Button from '@/design/components/buttons/base.vue';
import EditCard from '@/design/components/edit-card/index.vue';
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const sectionDesc = `与PPT生成视频协同，有言还提供从AI生成PPT、PPT生成可交互智能体（PPT Speak）的完整工具链，全面解放您的生产力。
`;

const cardList = [
  {
    title: 'AIPPT',
    des: '告诉AI你想要演讲的内容主题，或上传已经准备好的演讲文案，AI自动提取关键信息，生成内容大纲和PPT。PPT支持单独下载，也可生成AI数字人视频或创建PPT Speak智能体。',
    path: transformImage(getFeUrl('/youyan-platform/ppt-tools/ai-ppt-card.jpg')),
    freeLink: '/editor/page/ppt',
    name: PageKey.AI_PPT,
  },
  {
    title: 'PPT Speak（PPT转智能体工具）',
    des: '上传你的PPT，有言自动生成可问答互动的3D数字人智能体，告别单向视频播放，知识真正活起来。独有的PPT智能知识库与双模式体验，让内容从“被动灌输”变为“主动探索”。',
    path: transformImage(getFeUrl('/youyan-platform/ppt-tools/chat-ppt-card.jpg')),
    freeLink: '/editor/page/chat',
    name: PageKey.PPT_SPEAK,
  },
];

const handleTrial = (link?: string) => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(`/login?redirect=${encodeURIComponent(`${window.location.origin}${link}`)}`);
  } else {
    window.open(window.location.origin + link, '_blank');
  }
};

const handleViewDetail = (name?: string) => {
  router.push({
    name: `${name}`,
  });
};
</script>

<style lang="scss" scoped>
.interact-section__card-list {
  display: flex;
  gap: 40px;
  align-items: center;
}
.interact-section__card-btns {
  display: flex;
  align-items: center;
  gap: 24px;
}
.interact-section__card-btn {
  width: 178px;
}
</style>
